export default "/_next/static/chunks/fonts/Calibri-Italic-2af927c11f2bba525deb3bab263eec44.ttf";